<template>
  <div class="buy-points-select pb-1">
    <b-dropdown right class="btn btn-dropdown text-white">
      <template slot="button-content">
        <div class="w-100 p-2 text-left dropdown-text" style="border: 1px solid #cccccc; border-radius: 3px">
          {{ isReset ? $t('BetSlip.Buy Points') : line_selection.PointsPurchased }}
          <i class="icon icon-arrow-bottom float-right mt-1"></i>
        </div>
      </template>
      <b-dropdown-item :class="{ selected: selected === 0 }" @click="onBuyPointsNeutral(line_selection)">{{
        $t('BetSlip.Buy Points')
      }}</b-dropdown-item>
      <b-dropdown-item
        :class="{ selected: selected === opt.Point }"
        v-for="opt in line_selection.AvailableBuyPoints"
        :key="opt.OutComeId"
        @click="onBuyPointsChange(opt, line_selection)"
        >{{ opt.PointVal }}</b-dropdown-item
      >
    </b-dropdown>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

import { BDropdown, BDropdownItem } from 'bootstrap-vue';

export default {
  components: {
    BDropdown,
    BDropdownItem,
  },
  data() {
    return {
      selected: null,
      isReset: true,
    };
  },
  props: ['line_selection'],
  methods: {
    ...mapActions({
      updatePointsSelection: 'betSlip/updatePointsSelection',
    }),
    onBuyPointsChange(opt, line_selection) {
      this.isReset = false;
      line_selection.Point = opt.Point;
      this.selected = opt.Point;
      this.updatePointsSelection({
        selection_identifier: line_selection.OutComeId,
        points: line_selection.Point, // from buy_points
        current_identifier: opt.OutComeId,
      });
      this.$emit('change');
    },
    onBuyPointsNeutral(line_selection) {
      this.isReset = true;
      line_selection.Point = line_selection.OriginalPoint;
      this.selected = 0;
      this.updatePointsSelection({
        selection_identifier: line_selection.OutComeId,
        points: line_selection.Point,
        current_identifier: line_selection.OutComeId,
        reset_buy_point: true,
      });
      this.$emit('change');
    },
  },
};
</script>

<style lang="scss">
.buy-points-select {
  font-size: 12px !important;

  button {
    font-size: 12px !important;

    div {
      height: 32px !important;
      padding: 0 10px 0 10px !important;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border: 1px solid #b5bdca !important;
    }
  }
  .btn-dropdown {
    box-shadow: none !important;
    border-radius: 0;
    padding: 0px;
    text-align: left;
    width: 100%;

    .dropdown-menu {
      transform: translate3d(0px, 32px, 0px);
      width: 100%;
      border: none !important;
      box-shadow: 2px 2px 9px rgba(92, 92, 92, 0.16);
      border-radius: 4px;
      padding: 0;
      overflow: hidden;
    }

    .dropdown-text,
    .icon {
      color: #495057;
    }

    &.show {
      .dropdown-text {
        color: #495057;
      }
    }

    .dropdown-toggle {
      padding: 0px;
    }

    button {
      background: transparent !important;
      border: none !important;
      box-shadow: none !important;
      padding: 10px;
      width: 100%;
      text-align: left;

      &:after {
        display: none;
      }

      &:hover {
        background: transparent;
      }
    }

    &:after {
      border-top-color: #606381;
    }
  }

  .dropdown-item {
    cursor: pointer !important;
    padding-left: 15px;
    width: 100%;
    font-size: 12px !important;
    height: 30px;
    display: flex;
    align-items: center;
    color: #495057;

    &:hover {
      background: #f8f9fa;
    }

    &:hover,
    &.active {
      color: var(--color3);
    }

    &:last-child {
      border-bottom: none;
    }
  }

  .selected {
    .dropdown-item {
      background: #f8f9fa;
      color: var(--color3);
    }
  }

  .dropdown.show .icon.icon-arrow-bottom {
    transform: rotate(180deg);
  }
}
.text-div-test {
  background: red;
}
</style>
